const guardedAttribute = "data-more-pos-transient-credential";

function setNativeInputValue(input: HTMLInputElement, value: string) {
  const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
  descriptor?.set?.call(input, value);
  input.dispatchEvent(new Event("input", { bubbles: true }));
  input.dispatchEvent(new Event("change", { bubbles: true }));
}

function unlockOnIntent(input: HTMLInputElement) {
  const unlock = () => {
    input.readOnly = false;
  };

  input.addEventListener("pointerdown", unlock, { once: true });
  input.addEventListener("keydown", unlock, { once: true });
  input.addEventListener("focus", unlock, { once: true });
}

function guardTransientInput(input: HTMLInputElement, autocomplete: string) {
  if (input.getAttribute(guardedAttribute) === "true") return;

  input.setAttribute(guardedAttribute, "true");
  input.setAttribute("autocomplete", autocomplete);
  input.setAttribute("data-1p-ignore", "true");
  input.setAttribute("data-lpignore", "true");
  input.setAttribute("data-form-type", "other");
  input.readOnly = true;
  setNativeInputValue(input, "");
  unlockOnIntent(input);
}

function guardPosPin(pin: HTMLInputElement) {
  guardTransientInput(pin, "one-time-code");

  const form = pin.closest("form");
  if (!form) return;

  const employeeCode = Array.from(form.querySelectorAll<HTMLInputElement>("input")).find(
    (input) => input !== pin && input.type === "text" && !input.inputMode,
  );

  if (employeeCode) {
    guardTransientInput(employeeCode, "off");
  }
}

function scan(root: ParentNode) {
  root
    .querySelectorAll<HTMLInputElement>('input[type="password"][inputmode="numeric"]')
    .forEach(guardPosPin);
}

export function registerTransientPosCredentialGuard() {
  if (typeof document === "undefined" || typeof MutationObserver === "undefined") return;

  scan(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches('input[type="password"][inputmode="numeric"]')) {
          guardPosPin(node as HTMLInputElement);
        }
        scan(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}
